var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.$parent.adsvisible)?_c('div',{staticClass:"container mb-2"},[_c('div',{attrs:{"id":"vwc-container"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }